export const ENTITY_STATE_DELETE = 'DELETE';


// WEBPACK FOOTER //
// ./src/utils/constants.js